import { render, staticRenderFns } from "./driver_manager_individual.vue?vue&type=template&id=581d06d1&scoped=true&"
import script from "./driver_manager_individual.vue?vue&type=script&lang=js&"
export * from "./driver_manager_individual.vue?vue&type=script&lang=js&"
import style0 from "./driver_manager_individual.vue?vue&type=style&index=0&id=581d06d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d06d1",
  null
  
)

export default component.exports